<template>
    <div class="classify-box">
        <a-row :gutter="[10, 10]">
            <a-col :xl="6" :lg="6" :xs="12" style="text-align: left">
                <a-select style="width: 100%" allowClear v-model="searchParams.status" :placeholder="$t('submission.is_open' /* 是否开放 */)">
                    <a-select-option :value="1">{{ $t('submission.status_open' /* 开放 */) }}</a-select-option>
                    <a-select-option :value="2">{{ $t('submission.status_closed' /* 未开放 */) }}</a-select-option>
                </a-select>
            </a-col>
            <a-col :xl="6" :lg="6" :xs="12" style="text-align: left">
                <a-input v-model="searchParams.name" :placeholder="$t('submission.category_name_placeholder' /* 请输入分类名称 */)" />
            </a-col>
            <a-col :xl="6" :lg="6" :xs="12" style="text-align: left">
                <a-button type="primary" @click="getList" style="">{{ $t('web.search' /* 搜索 */) }}</a-button>
            </a-col>
        </a-row>
        <div class="mt15">
            <a-button type="primary" icon="plus" @click="handleEdit('')">{{ $t('submission.add_channel_button' /* 添加渠道 */) }}</a-button>
        </div>
        <!--   表格 增加key是因为defaultExpandAllRows不生效的    -->
        <a-table
            :key="dataSource.length"
            :rowKey="record => record.channel_id"
            :columns="columns"
            :data-source="dataSource"
            :custom-row="customRow"
            :scroll="{ x: 1000 }"
            :loading="loading"
            :pagination="false"
            class="mt15"
            size="middle"
        >
            <template slot="drag" slot-scope="text, record">
                <i class="medcon fs24 med-Drag"></i>
            </template>
            <span slot="status" slot-scope="text, record, index">
                <!--  v-if="record.name?.cn != '日程'" -->
                <a-switch @change="handleChangeStatus(record)" :checked="record.is_open == 1" :checked-children="$t('web.open' /* 开启 */)" :un-checked-children="$t('web.close' /* 关闭 */)" />
            </span>
            <span slot="abstract_max_num" slot-scope="text, record, index">
                {{ record.abstract_max_num == 0 ? $t('submission.no_limit' /* 不限制 */) : $t('submission.max_send_num' /* 最大投稿数 */) + record.abstract_max_num }}
            </span>
            <span slot="language" slot-scope="text, record, index">
                {{ record.cnen == 'cn' ? $t('submission.cn_web' /* 中文网站 */) : $t('submission.en_web' /* 英文网站 */) }}
            </span>

            <span slot="action" slot-scope="text, record, index">
                <a-button type="link" @click="handleEdit(record.channel_id)">{{ $t('submission.channel_config' /* 渠道配置 */) }}</a-button>
                <router-link :to="`/submission/abstract-channel-form-params/cn/${$route.params.meeting_id}?channel_id=${record.channel_id}&form_type=${21}&custom_type=author`">
                    <a-button style="padding: 0 10px" type="link">{{ $t('submission.first_author' /* 第一作者 */) }}</a-button>
                </router-link>
                <router-link :to="`/submission/abstract-channel-form-params/cn/${$route.params.meeting_id}?channel_id=${record.channel_id}&form_type=${22}&custom_type=author`">
                    <a-button style="padding: 0 10px" type="link">{{ $t('submission.other_author' /* 其他作者 */) }}</a-button>
                </router-link>
                <!-- <router-link :to="`/submission/abstract-channel-form-params/cn/${$route.params.meeting_id}?channel_id=${record.channel_id}&form_type=${23}&custom_type=author`"><a-button style="padding:0 10px;" type="link">通讯作者</a-button></router-link> -->
                <router-link :to="`/submission/abstract-channel-form-params/cn/${$route.params.meeting_id}?channel_id=${record.channel_id}&form_type=${24}&custom_type=thesis`">
                    <a-button style="padding: 0 10px" type="link">{{ $t('submission.collect_content' /* 论文收集内容 */) }}</a-button>
                </router-link>
                <router-link :to="`/submission/abstract-channel-form-params/cn/${$route.params.meeting_id}?channel_id=${record.channel_id}&form_type=${25}&custom_type=upload`">
                    <a-button style="padding: 0 10px" type="link">{{ $t('submission.upload_collect' /* 上传资料收集 */) }}</a-button>
                </router-link>
                <a-button style="padding: 0 10px" type="link" @click="handleDelete(index)" class="del-button">{{ $t('web.delete' /* 删除 */) }}</a-button>
            </span>
        </a-table>
        <updateChannelModal :list="dataSource" @success="getList()" ref="updateChannelModalRef" />
    </div>
</template>

<script>
import tableDrag from '@/utils/table.drag.mixins.js';
import updateChannelModal from '../components/update-channel-modal.vue';
export default {
    name: 'SubmissionClassParams',
    mixins: [tableDrag],
    components: {
        updateChannelModal
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t('web.sort' /* 排序 */),
                    scopedSlots: { customRender: 'drag' },
                    width: 80
                },
                {
                    title: this.$t('submission.channel_name' /* 渠道名称 */),
                    dataIndex: 'title',
                    align: 'center',
                    width: 200
                },
                {
                    title: this.$t('submission.submission_limit_column' /* 投稿限制 */),
                    scopedSlots: { customRender: 'abstract_max_num' },
                    dataIndex: 'abstract_max_num',
                    width: 150
                },
                {
                    title: this.$t('submission.manuscript_language' /* 稿件语言 */),
                    scopedSlots: { customRender: 'language' },
                    dataIndex: 'language',
                    width: 100
                },
                {
                    title: this.$t('submission.is_open' /* 是否开放 */),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center'
                }
            ],
            searchParams: {},
            dataSource: [],
            loading: false,
            // 分页
            pagination: {
                page: 1,
                limit: 999999
            }
        };
    },
    mounted() {},
    methods: {
        getList() {
            this.$request.post({ url: 'getSubmissionChannelList', data: { ...this.searchParams, ...this.pagination } }).then(res => {
                // 排序mixin中使用到了
                res.data.list.forEach(item => {
                    item.id = item.channel_id;
                });
                this.dataSource = res.data.list;
                this.loading = false;
            });
        },
        /**
         * @param {*} channel_id
         */
        handleEdit(channel_id) {
            this.$refs.updateChannelModalRef.showFun(channel_id);
        },
        handleDelete(index) {
            let record = this.dataSource[index];
            // 弹窗确实是或者否
            this.$confirm({
                title: this.$t('web.tips' /* 提示 */),
                content: this.$t('submission.delete_channel' /* 您确定要删除当前渠道吗？ */),
                okText: this.$t('web.ok' /* 确定 */),
                cancelText: this.$t('web.cancel' /* 取消 */),
                onOk: () => {
                    let data = {
                        id: record.channel_id
                    };
                    this.$request
                        .post({ url: 'deleteSubmissionChannel', data })
                        .then(res => {
                            this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                            this.dataSource.splice(index, 1);
                        })
                        .catch(err => {
                            this.$message.error(this.$t('web.delete_fail' /* 删除失败 */));
                        });
                },
                onCancel: () => {
                    console.log('取消');
                }
            });
        },
        handleChangeStatus(record) {
            let status = record.is_open == 1 ? 0 : 1;
            let data = {
                id: record.channel_id,
                status
            };
            this.$request.post({ url: 'updateSubmissionChannelStatus', data }).then(res => {
                record.is_open = status;
                this.$message.success(this.$t('submission.status_update_success' /* 状态修改成功 */));
            });
        },
        // 拖拽排序
        dragSuccess() {
            // 排序列表默认取父级
            let sortArr = [];
            this.dataSource.forEach((item, index) => {
                sortArr.push({
                    data_id: item.channel_id,
                    sort: index + 1
                });
            });
            this.$request.post({ url: 'sortSubmissionChannel', data: { sorts: JSON.stringify(sortArr) } }).then(res => {
                console.log(res);
            });
        }
    },
    created() {
        this.loading = true;
        this.getList();
    }
};
</script>
